import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import Dashboard from './components/dashboard/Dashboard';
import PlayerList from './components/players/PlayerList';
import TacticsBoard from './components/tactics/TacticsBoard';
import Matchday from './components/Matchday';
import EventList from './components/events/EventList';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import PrivateRoute from './components/auth/PrivateRoute';
import Training from './components/training/DrillManager';
import Messages from './components/messages/Messages';
import TeamManagement from './components/team-management/TeamManagement';
import UserManagement from './components/user-management/UserManagement';
import Settings from './components/settings/Settings';
import Navbar from './components/navigation/Navbar';
import Navigation from './components/navigation/Navigation';
import Payments from './components/payments/Payments';
import { useAuthContext } from './context/AuthContext';

const App: React.FC = () => {
  const { user } = useAuthContext();
  return (
    <>
      <Router>

        <div className="container mx-auto px-4">

          <Navbar />

          {user && <Navigation />}
          
          <div className="bg-white rounded-xl p-4 h-full">
            <Routes>
              <Route path='/' element={<Navigate to='/dashboard' replace />} />
              <Route
                path='/dashboard'
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path='/players'
                element={
                  <PrivateRoute>
                    <PlayerList />
                  </PrivateRoute>
                }
              />
              <Route path='/schedule' element={<EventList />} />

              <Route
                path='/tactics'
                element={
                  <PrivateRoute>
                    <TacticsBoard />
                  </PrivateRoute>
                }
              />
              <Route
                path='/training'
                element={
                  <PrivateRoute>
                    <Training />
                  </PrivateRoute>
                }
              />
              <Route
                path='/payments'
                element={
                  <PrivateRoute>
                    <Payments />
                  </PrivateRoute>
                }
              />
              <Route
                path='/messages'
                element={
                  <PrivateRoute>
                    <Messages />
                  </PrivateRoute>
                }
              />
              <Route
                path='/settings'
                element={
                  <PrivateRoute>
                    <Settings />
                  </PrivateRoute>
                }
              />
              <Route
                path='/team-management'
                element={
                  <PrivateRoute>
                    <TeamManagement />
                  </PrivateRoute>
                }
              />
              <Route
                path='/user-management'
                element={
                  <PrivateRoute>
                    <UserManagement />
                  </PrivateRoute>
                }
              />
              <Route path='/login' element={<Login />} />
              <Route path='/register' element={<Register />} />
            </Routes>
          </div>
        </div>
        
      </Router>
    </>
  );
};

export default App;
